var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (!_vm.isFetching) ? _c('tariff-buy', {
    attrs: {
      "onCreatePayment": _vm.createPayment,
      "onBuyTariff": _vm.buyTariff,
      "tariff": _vm.viewedTariff,
      "hasTariff": _vm.hasTariff,
      "products": _vm.products,
      "is-filled": _vm.isFilled,
      "is-identified": _vm.isIdentified,
      "balance": _vm.balance
    }
  }) : _vm._e()
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78fefcd3","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/tariffBuy/TariffBuyContainer.vue
// module id = 993
// module chunks = 0